import {
  Dispatch,
  FC,
  MouseEvent,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useNavigate, useLocation, useParams } from 'react-router';
import PageHeader from 'Components/UI/PageHeader/PageHeader';
import BreadCrumb, { IBreadcrumbItem } from 'Components/UI/BreadCrumb';
import Table from 'Components/UI/Table';
import TableActionTopbar from 'Components/UI/TableActionTopbar';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { connect, ConnectedProps, useDispatch, useSelector } from 'react-redux';
import { ListagemArquivosActions } from 'Store/ListagemArquivos/ListagemArquivos.actions';
import emptyListImage from 'Static/images/computer-upload.png';
import { useTimeout } from 'Context/TimeoutContext';
import {
  getBreadCrumb,
  getColumnsTable,
  getColumnsTableEdit,
  IRequestPlotColumns,
  getBreadCrumbDefault,
} from './ListagemArquivos.columns';
import {
  changeStatusFiles,
  getButtonsTableToolbar,
  handleOpenFileLink,
  IListSaveOrder,
  handleOpenForgeViewer,
  renameFile,
  sortList,
  updateFileInfo,
  updateUploadState,
  handleOpenCoordly2DViewer,
} from './ListagemArquivos.helpers';
import FileDrop from 'Components/UI/FileDrop';
import { Http } from 'Utils/Http';
import ExclusaoArquivos, {
  IDeleteFilesComponentRequest,
} from './Modals/ExclusaoArquivos';
import NovaPasta from './Modals/NovaPasta';
import AvisoTamanhoEQuantidadeArquivos from './Modals/AvisoTamanhoEQuantidadeArquivos';
import { ICreateFolderRequest } from 'Data/interfaces/Obra/ICreateFolderRequest';
import './ListagemArquivos-override.css';
import SolicitacaoPlotagem from './SolicitacaoPlotagem';
import { IUnarchiveFilesRequest } from 'Data/interfaces/Obra/IUnarchiveFilesRequest';
import SignalR from 'Components/UI/SignalR';
import { mapNotification } from 'Utils/ObraUtils';
import UpdateStatus from 'Components/UI/UpdateStatusList';
import DownloadModal from 'Components/UI/ModalDownload';
import AvisoRenderizacaoUpgrade from 'Components/UI/AvisoRenderizacaoUpgrade';
import LoadingArchives from 'Components/UI/CustomLoading/LoadingArchives';
import { FileStatusEnum, IFileData } from 'Data/interfaces/ListagemArquivos/IListFilesResponse';
import ProgressRenderBar from './Modals/ProgressRenderBar';
import EdicaoNomenclatura from './Components/EdicaoNomenclatura/EdicaoNomenclatura';
import AppStorage from 'Utils/AppStorage';
import { ViewerActions } from 'Store/Viewer/Viewer.actions';
import { ConfigProvider, Empty } from 'antd';
import CustomEmptyData from 'Components/UI/CustomEmptyData';
import TabsShell, { PathActiveEnum } from 'Components/UI/TabsShell';
import { DisciplineIconsEnum } from 'Pages/Disciplinas';
import { ObraActions } from 'Store/Obra/Obra.actions';
import DownloadBloqueadosModal, { IBlockedParams } from './Modals/DownloadBloqueadosModal';
import { IDownloadFilesRequest } from 'Data/interfaces/Obra/IDownloadFilesRequest';
import VisualizacaoBloqueadosModal from './Modals/VisualizacaoBloqueadosModal';
import AvisoUploadUpgrade from './Modals/AvisoUploadUpgrade';
import { useFeatureFlag } from 'Hooks/useFeatureFlag';
import { Mixpanel } from 'Utils/MixPanel';
import useWindowSize from 'Hooks/useWindowSize';
import { DisciplinaActions } from 'Store/Disciplina/Disciplina.actions';
import { getCurrentTenant, getTenants } from 'Store/Tenant/Tenant.selector';
import { HistoryActions } from 'Store/History/History.actions';
import { IHistoryFileRequestList } from 'Data/interfaces/History/IHistoryFileApi';
import { UploadActions } from 'Store/Upload/Upload.actions';
import NewEdicaoNomenclatura from './Components/NewEdicaoNomenclatura/NewEdicaoNomenclatura';
import toastHandler from 'Utils/toastHandler';
import { useQueryInAppObraNotifications } from 'Hooks/notifications/useQueryInAppObraNotifications';
import {
  INotificationInAppObra,
  INotificationMultipleReadRequest,
} from 'Data/interfaces/Notification/INotification';
import { IFileRenameData } from 'Data/interfaces/ListagemArquivos/IFileRenameRequest';
import { useNotification } from 'Context/NotificationContext';
import { IContextMenuRef } from 'Components/UI/ContextMenu/model';
import ContextMenu from 'Components/UI/ContextMenu';
import MoreActionsDropdownContent from './Components/MoreActionsDropdownContent';
import MoveFilesModal from './Modals/MoveFilesModal';
import { extensions2dAnd3d, useCoordlyViewerFeature } from 'Utils/ViewerUtils';
import AccessPermission from 'Utils/AcessPermission';
import styles from './ListagemArquivos.module.scss';

export const RELOAD_LISTAGEM_ARQUIVOS_KEY = 'RELOAD_LISTAGEM_ARQUIVOS_KEY';

export interface IOpenMoreActionsDropdown {
  open: boolean;
  id: string | null;
}

export interface IOpenFileAction {
  csId: number;
  ConstructionSiteDisciplinesId: number;
  record: IFileData;
  constructionSiteName: string;
  breadCrumbId: number | string;
  dispatch: Dispatch<any>;
  constructionSiteApiId: number;
  event: number;
}

export interface IOpenVisualizationBlockedFileAction {
  path: string;
  newWindown: boolean;
}

const ListagemArquivos: FC<Props> = ({
  Obra,
  BreadCrumbItem,
  ListFiles,
  filters,
  selectedEditRowKeys,
  showEditTable,
  showPlotRequestTable,
  isLoadingFileList,
  nomenclature,
  editFormIndex,
  isLoading,
  isDownloading,
  showModalDeleteFiles,
  showModalCreateFolder,
  showModalInfoFiles,
  ObsoleteFolderId,
  isLoadingRenameFile,
  TenantUsers,
  notificationsMapOld,
  CloudServiceFolderUrl,
  userInfo,
  planFree,
  userLimitsActive,
  loadObsoleteFiles,
  isLoadingFilesObsoleteList,
  openLink,
  currentUserPrivileges,
  isLoadingUpdateStatus,
  statusUpdateStatus,
  dateUpdateStatus,
  isShellCollapsed,
  listArchivesNewDisciplineNoCache,
  error,
}) => {
  const downloadViaStreamFlag = useFeatureFlag('download-via-stream');
  const downloadViaStream = downloadViaStreamFlag.enabled && downloadViaStreamFlag.value === 'test';
  const stagesFeatureValidateFlag = useFeatureFlag('stages-feature-validate');
  const stagesFeatureValidate = stagesFeatureValidateFlag.enabled && stagesFeatureValidateFlag.value === 'test';
  const followFolderFeatureFlag = useFeatureFlag('follow-folder-feature');
  const followFolderFeature = followFolderFeatureFlag.enabled && followFolderFeatureFlag.value === 'test';
  const newMoveFilesFeatureFlag = useFeatureFlag('new-move-files-feature');
  const newMoveFilesFeature = newMoveFilesFeatureFlag.enabled && newMoveFilesFeatureFlag.value === 'test';

  const dispatch = useDispatch();
  const { set, clear } = useTimeout();
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const tenants = useSelector(getTenants);
  const currentTenant = useSelector(getCurrentTenant);
  const {
    data: inAppNotifications,
  } = useQueryInAppObraNotifications(Number(params.constructionSiteId));
  const { addNotificationsToRead } = useNotification();

  const { height, width } = useWindowSize();
  const isLoadingCache = useSelector(
    (state: IGlobalReducerState) => state.updateStatus.isLoading,
  );
  const breadCrumbId = Http.GetQueryParams('breadCrumbId');
  const onlyFolder = Http.GetQueryParams('onlyFolder');
  const isObsoleteFolder = Http.GetQueryParams('isObsoleteFolder') === 'true';
  const folderName = Http.GetQueryParams('folderName');
  const obraApi = Http.GetQueryParams('obraApi');
  const ConstructionSiteDisciplinesId = Number(
    Http.GetQueryParams('ConstructionSiteDisciplinesId'),
  );
  const DisciplineName = Http.GetQueryParams('DisciplineName');
  const itemIdNotification = mapNotification(notificationsMapOld, true);
  const filterNotification = mapNotification(notificationsMapOld);
  const requestPlotListFiles: IRequestPlotColumns[] = ListFiles.filter((file: any) =>
    selectedEditRowKeys.includes(file.Identifier.ApiId || file.Identifier.ItemId),
  )
    .filter((file: any) => file.Status !== 0)
    .map((file: any, index: number) => ({
      Name: file?.Name,
      HasColor: false,
      Extension: file?.Extension,
      key: index,
      FileInfoFk: file?.FileInfo?.FileInfoId || null,
      FileApiId: file?.FileInfo?.ApiId || null,
    }));

  const firstOpen = useRef(0);
  const contextMenuRef = useRef<IContextMenuRef>(null);
  const initializeLoadingCheckNotifications = useRef(false);
  const [breadCrumbs, setBreadCrumbs] = useState<IBreadcrumbItem[]>([]);
  const [isFileListRequest, setIsFileListRequest] = useState(false);
  const [showModalLimitRenderFiles, setShowModalLimitRenderFiles] = useState(false);
  const [showModalRenderUpgrade, setShowModalRenderUpgrade] = useState(false);
  const [showModalDownloadBlockedFiles, setShowModalDownloadBlockedFiles] = useState(
    false,
  );
  const [showModalUpgradeUpload, setShowModalUpgradeUpload] = useState(false);
  const { isCoordly2DViewerEligible } = useCoordlyViewerFeature();
  const [
    showModalVisualizationBlockedFiles,
    setShowModalVisualizationBlockedFiles,
  ] = useState(false);
  const [
    hasPermissionVisualizationBlockedFiles,
    setHasPermissionVisualizationBlockedFiles,
  ] = useState(false);
  const [openFileVisualizationLinkStatus, setOpenFileVisualizationLinkStatus] = useState(
    {} as IOpenVisualizationBlockedFileAction,
  );
  const [blockedParams, setBlockedParams] = useState<IBlockedParams>({
    hasPermission: false,
    isBlocked: false,
    hasBlockedFolders: false,
    hasMultipleFiles: false,
  });
  const [openFileAction, setOpenFileAction] = useState({} as IOpenFileAction);
  const [activeRow, setActiveRow] = useState<string[]>([]);
  const [searchArchives, setSearchArchives] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState<IFileData[]>([]);
  const [deleteFilesRequest, setDeleteFilesRequest] = useState(
    {} as IDeleteFilesComponentRequest,
  );
  const [editFolder, setEditFolder] = useState<IFileData | null>(null);
  const [openMoreActionsDropdown, setOpenMoreActionsDropdown] = useState<IOpenMoreActionsDropdown>({
    open: false,
    id: null,
  });
  const [contextMenuRecord, setContextMenuRecord] = useState<IFileData | null>(null);
  const [showMoveFilesModal, setShowMoveFilesModal] = useState(false);
  const [newFolderWithDestination, setNewFolderWithDestination] = useState<string | null>(null);
  const [canReadNow, setCanReadNow] = useState(false);

  const notificationsObj = useMemo(() => {
    const foldersIds = [];
    const notificationsMap: Record<string, INotificationInAppObra[]> = {};
    for (const notification of inAppNotifications) {
      if (notification.ItemId in notificationsMap) {
        notificationsMap[notification.ItemId].push(notification);
      } else {
        notificationsMap[notification.ItemId] = [notification];
      }
      if (notification?.Folders?.length > 0) {
        foldersIds.push(...notification.Folders, notification.ItemId);
      }
    }
    return { foldersIds, notificationsMap };
  }, [inAppNotifications]);

  const request = useMemo(() => {
    const result: any = { ...params };

    if (breadCrumbId) {
      result['breadCrumbId'] = breadCrumbId;
    }

    if (onlyFolder) {
      result['onlyFolder'] = onlyFolder;
    }

    if (isObsoleteFolder) {
      result['isObsoleteFiles'] = isObsoleteFolder;
    }

    if (folderName) {
      result['folderName'] = folderName;
    }

    if (obraApi) {
      result['api'] = obraApi;
    }

    result['googleDriveExperiment'] = 'test';

    if (userInfo) {
      result['userInfoTracking'] = userInfo;
    }

    if (currentTenant) {
      result['currentTenantTracking'] = currentTenant;
    }

    if (tenants) {
      result['tenantIds'] = tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined);
    }

    if (!(window as any)[RELOAD_LISTAGEM_ARQUIVOS_KEY]) {
      result['ignoreCache'] = true;
      (window as any)[RELOAD_LISTAGEM_ARQUIVOS_KEY] = true;
    }

    if (listArchivesNewDisciplineNoCache) {
      result['ignoreCache'] = true;
    }

    return result;
  }, [
    breadCrumbId,
    folderName,
    isObsoleteFolder,
    params,
    obraApi,
    onlyFolder,
    currentTenant,
    tenants,
    userInfo,
    listArchivesNewDisciplineNoCache,
  ]);

  useEffect(() => {
    if (
      firstOpen.current === 0 &&
      Obra?.Name &&
      DisciplineName &&
      Obra.ConstructionSiteId === Number(params.constructionSiteId)
    ) {
      if (DisciplineName === folderName) {
        Mixpanel.track({
          name: 'PAGE_VIEW',
          props: {
            constructionSiteId: Number(params.constructionSiteId),
            disciplineId: ConstructionSiteDisciplinesId,
            disciplineApiFolderId: params.folderId,
            disciplineName: DisciplineName,
          },
          userInfo,
          currentListTenant: currentTenant,
          tenantIds: tenants && tenants.length > 0
            ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
            : undefined,
        });
      } else {
        Mixpanel.track({
          name: 'PAGE_VIEW',
          props: {
            constructionSiteId: Number(params.constructionSiteId),
            disciplineId: ConstructionSiteDisciplinesId,
            disciplineName: DisciplineName,
            folderId: params.folderId,
            folderName,
          },
          userInfo,
          currentListTenant: currentTenant,
          tenantIds: tenants && tenants.length > 0
            ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
            : undefined,
        });
      }
      firstOpen.current++;
    }
  }, [Obra]);

  useEffect(() => {
    if (
      AppStorage.GetItem('listFilesOrder') &&
      !isLoadingFileList &&
      !isLoadingFilesObsoleteList &&
      !isLoadingUpdateStatus
    ) {
      const listFilesSaveOrder: IListSaveOrder = JSON.parse(
        AppStorage.GetItem('listFilesOrder') ?? '',
      );
      sortList(
        listFilesSaveOrder.dataIndex,
        listFilesSaveOrder.sortOrder,
        ListFiles,
        dispatch,
      );
    }
  }, [isLoadingFileList, isLoadingFilesObsoleteList, isLoadingUpdateStatus]);

  useEffect(() => {
    dispatch(ListagemArquivosActions.listFiles(request));
    dispatch(ListagemArquivosActions.listFilesMoveToClear());
    if (listArchivesNewDisciplineNoCache) {
      dispatch(DisciplinaActions.listArchiveNewDisciplineNoCache(null));
    }
  }, [
    params.folderId,
    breadCrumbId,
    onlyFolder,
    isObsoleteFolder,
    listArchivesNewDisciplineNoCache,
  ]);

  useEffect(() => {
    if (loadObsoleteFiles && !isObsoleteFolder) {
      request['loadObsoleteFiles'] = loadObsoleteFiles;
      dispatch(ListagemArquivosActions.filesVersion(request));
    }
    if (loadObsoleteFiles && isObsoleteFolder) {
      dispatch(ListagemArquivosActions.loadObsoleteFiles(false));
    }
  }, [loadObsoleteFiles]);

  useEffect(() => {
    if (isLoadingFileList && !isFileListRequest) {
      setIsFileListRequest(true);
    }
  }, [isLoadingFileList]);

  useEffect(() => {
    dispatch(ViewerActions.setOpenFileLink(''));
    dispatch(UploadActions.checkUploadFilesInfoClear());

    return () => clear('canReadNow');
  }, []);

  useEffect(() => {
    const pathname = location?.pathname || '';
    const search = location?.search;
    dispatch(
      ObraActions.storeArchivesPath({
        params,
        path: pathname,
        url: `${pathname}${search}`,
      }),
    );
  }, [params, location, dispatch]);

  useEffect(() => {
    if (isLoadingFileList || Obra.ConstructionSiteId === undefined) {
      setBreadCrumbs(getBreadCrumbDefault(BreadCrumbItem));
      dispatch(ListagemArquivosActions.setSelectedEditRowKeys([]));
    } else {
      setBreadCrumbs(
        getBreadCrumb(
          Obra,
          BreadCrumbItem,
          ConstructionSiteDisciplinesId,
          isObsoleteFolder,
        ),
      );
    }
  }, [
    BreadCrumbItem,
    Obra,
    Obra.ConstructionSiteId,
    isLoadingFileList,
    ConstructionSiteDisciplinesId,
    isObsoleteFolder,
  ]);

  useEffect(() => {
    if (!isLoadingRenameFile) {
      setActiveRow([]);
    }
  }, [isLoadingRenameFile]);

  useEffect(() => {
    if (
      !initializeLoadingCheckNotifications.current &&
      isLoading &&
      isLoadingFileList
    ) {
      initializeLoadingCheckNotifications.current = true;
      return;
    }

    // Marcar novas notificações como 'vistas'
    if (
      initializeLoadingCheckNotifications.current &&
      !error &&
      !isLoadingFileList &&
      !isLoading &&
      params?.constructionSiteId &&
      params?.folderId &&
      inAppNotifications &&
      inAppNotifications.length > 0 &&
      ListFiles &&
      ListFiles.length >= 0
    ) {
      if (!canReadNow) {
        clear('canReadNow');
        set('canReadNow', () => {
          setCanReadNow(true);
        }, 600);
      } else {
        const filesHasNotifications: INotificationInAppObra[] = [];
        const notificationAsView: INotificationMultipleReadRequest = {
          constructionSiteId: Number(params.constructionSiteId),
          itemAuxId: params.folderId,
          notificationIds: [],
        };
        for (const notification of inAppNotifications) {
          if (notification.Folders.length > 0) {
            const lastFolderId = notification.Folders[notification.Folders.length - 1];
            if (lastFolderId === params.folderId) {
              notificationAsView.notificationIds.push(notification.NotificationId);
            } else {
              const findFolderIndex = notification.Folders.findIndex((folder) => folder === params.folderId);
              if (findFolderIndex !== -1) {
                const afterFolder = notification.Folders[findFolderIndex + 1];
                if (afterFolder) {
                  const findFileIndex = ListFiles.findIndex((file) => file.Identifier.ApiId === afterFolder);
                  if (findFileIndex === -1) {
                    notificationAsView.notificationIds.push(notification.NotificationId);
                  }
                }
              }
            }
          }
          if (ListFiles.some((file) => file.Identifier.ApiId === notification.ItemId)) {
            filesHasNotifications.push(notification);
          }
        }
        for (const fileNotification of filesHasNotifications) {
          if (!notificationAsView.notificationIds.includes(fileNotification.NotificationId)) {
            notificationAsView.notificationIds.push(fileNotification.NotificationId);
          }
        }
        if (notificationAsView.notificationIds.length > 0) {
          addNotificationsToRead(
            params.folderId,
            notificationAsView,
          );
        }
      }
    }
  }, [
    error,
    ListFiles,
    isLoadingFileList,
    isLoading,
    inAppNotifications,
    params?.constructionSiteId,
    params?.folderId,
    addNotificationsToRead,
    canReadNow,
  ]);

  useEffect(() => {
    if (selectedEditRowKeys.length <= 1) {
      dispatch(
        ListagemArquivosActions.setShowModalDownloadMultipleFiles({ isVisible: false }),
      );
    }
  }, [selectedEditRowKeys]);

  const handleOpenMoreActionsDropdown = (id: string, open: boolean) => {
    if (!followFolderFeature) { return; }

    setOpenMoreActionsDropdown({
      open,
      id,
    });
  };

  const handleCloseMoreActionsDropdown = () => {
    setOpenMoreActionsDropdown({
      open: false,
      id: null,
    });
    handleCloseContextMenu();
  };

  const handleContextMenu = (e: MouseEvent, record: IFileData) => {
    if (!followFolderFeature) { return; }

    setContextMenuRecord(record);
    contextMenuRef.current?.show(e);
  };
  const menuId = `ActionMenuObra${params?.folderId}`;

  const onChange = (selecteds: any, selectedsData: any) => {
    dispatch(ListagemArquivosActions.setSelectedEditRowKeys(selecteds));
    setSelectedFiles(selectedsData);
    handleCloseContextMenu();
  };

  const rowSelection = {
    selectedRowKeys: selectedEditRowKeys,
    columnWidth: '5%',
    onChange,
  };

  const onSubmit = (values: any) => {
    let closable = true;

    let fullName = '';
    let nomenclatureCount = 0;

    nomenclatureCount = Obra.VersionConfig.VersionFields.length - 1;

    let newName = '';
    if (JSON.parse(`${values.hasNomenclatureControl}`)) {
      for (let i = 0; i <= nomenclatureCount; i++) {
        fullName += values[`field${i}`] + values[`separator${i}`];
      }
      newName = fullName.slice(0, -1) + '.' + values.extension;
    } else {
      newName = values.simpleFileName + '.' + values.extension;
    }

    if (values && !ListFiles.find((file: any) => file.Name === newName)) {
      closable = false;
      renameFile(values, BreadCrumbItem, dispatch);
    }

    if (
      !ListFiles.find(
        (file: any) =>
          (file.Identifier.ApiId === values.fileId ||
            file.Identifier.ItemId === values.fileId) &&
          (file.FileInfo.Description === values.description ||
            (!file.FileInfo.Description && !values.description)),
      )
    ) {
      closable = false;
      updateFileInfo(values, dispatch);
    }

    if (closable) {
      setActiveRow([]);
    }
  };

  const onChangeNomenclatureInList = (record: any) => {
    setActiveRow((prevState: string[]) =>
      prevState[0] === (record.Identifier.ApiId || record.Identifier.ItemId)
        ? []
        : [record.Identifier.ApiId || record.Identifier.ItemId],
    );
  };

  const openModalExclusaoArquivos = (file?: IFileData | null) => {
    setDeleteFilesRequest({
      filesToDelete: file ? [file] : selectedFiles,
      FolderId: BreadCrumbItem.Identifier,
      ObsoleteFolderId,
      ConstructionSiteId: Obra.ConstructionSiteId,
    });
    dispatch(ListagemArquivosActions.setShowModalDeleteFiles(true));
  };

  const closeModalExclusaoArquivos = () => {
    dispatch(ListagemArquivosActions.setShowModalDeleteFiles(false));
    handleCloseContextMenu();
  };

  const openModalDownloadMultiplesFiles = (hasFolder: boolean) => {
    if (downloadViaStream) {
      if (hasFolder) {
        return dispatch(
          ListagemArquivosActions.setShowModalDownloadMultipleFiles({
            isVisible: true,
            hasFolder: true,
          }),
        );
      } else {
        handleTrackDownloadMultiple();
        return handleDowload();
      }
    }

    if (hasFolder) {
      dispatch(
        ListagemArquivosActions.setShowModalDownloadMultipleFiles({
          isVisible: true,
          hasFolder: true,
        }),
      );
    } else {
      dispatch(
        ListagemArquivosActions.setShowModalDownloadMultipleFiles({ isVisible: true }),
      );
    }
  };

  const openModalDownloadBlockedFiles = (
    hasPermission: boolean,
    isBlocked: boolean,
    hasBlockedFolders: boolean,
    hasMultipleFiles: boolean,
  ) => {
    setBlockedParams({
      hasPermission,
      isBlocked,
      hasBlockedFolders,
      hasMultipleFiles,
    });
    setShowModalDownloadBlockedFiles(true);
  };

  const openModalVisualizationBlockedFiles = (hasPermission: boolean) => {
    dispatch(ViewerActions.setOpenFileLink(''));
    setHasPermissionVisualizationBlockedFiles(hasPermission);
    setShowModalVisualizationBlockedFiles(true);
  };

  const closeModalVisualizationBlockedFiles = () => {
    dispatch(ViewerActions.setOpenFileLink(''));
    setOpenFileVisualizationLinkStatus({} as IOpenVisualizationBlockedFileAction);
    setShowModalVisualizationBlockedFiles(false);
  };

  const openModalCriarPasta = (
    file?: IFileData,
    newFolderDestination?: string,
  ) => {
    setNewFolderWithDestination(newFolderDestination || null);
    if (file) {
      setEditFolder(file);
    } else {
      setEditFolder(null);
    }
    dispatch(ListagemArquivosActions.setShowModalCreateFolder(true));
  };

  const closeModalCriarPasta = () => {
    setNewFolderWithDestination(null);
    setEditFolder(null);
    dispatch(ListagemArquivosActions.setShowModalCreateFolder(false));
  };

  const handleDowload = (fileId?: string) => {
    const FilesId = fileId ? [fileId] : selectedEditRowKeys;
    const request: IDownloadFilesRequest = {
      api: Obra.Api,
      constructionSiteId: Obra.ConstructionSiteId || 0,
      itemsId: FilesId,
      constructionSiteName: Obra.Name,
      tenantName: Obra.TenantName,
      UserId: userInfo?.Id,
      userInfoTracking: userInfo,
      currentTenantTracking: currentTenant,
      tenantIds: tenants && tenants.length > 0
        ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
        : undefined,
    };

    if (downloadViaStream) {
      toastHandler.showInfo('Seu download está em andamento...');
      const url = `${process.env.REACT_APP_BASE_DOWNLOAD_URL
        }api/Download/stream?constructionSiteId=${Obra.ConstructionSiteId}&api=${Obra.Api
        }&itemsIds=${FilesId.join('&itemsIds=')}`;
      window.open(url, '_blank')?.focus();
    } else {
      dispatch(ListagemArquivosActions.downloadFiles(request));
      setShowModalDownloadBlockedFiles(false);
    }
  };

  const handleVisualizationBlockedFile = () => {
    if (openFileVisualizationLinkStatus.newWindown) {
      window.open(openFileVisualizationLinkStatus.path, '_blank', 'noopener,noreferrer');
    } else {
      handleOpenFileLink(
        openFileVisualizationLinkStatus.path,
        dispatch,
        navigate,
      );
    }

    setOpenFileVisualizationLinkStatus({} as IOpenVisualizationBlockedFileAction);
    setShowModalVisualizationBlockedFiles(false);
  };

  const desarquivarArquivos = () => {
    const FilesId = selectedEditRowKeys || [];
    const request: IUnarchiveFilesRequest = {
      ConstructionSiteId: Obra.ConstructionSiteId || 0,
      ObsoleteFolderId: BreadCrumbItem.Identifier,
      FolderId: BreadCrumbItem.PreviousItem?.Identifier || '',
      FilesId: FilesId || [],
    };
    dispatch(ListagemArquivosActions.unarchiveFiles(request));
  };

  const createFolder = (folderName: string, folderDestination?: string) => {
    if (Obra.ConstructionSiteId) {
      const request: ICreateFolderRequest = {
        ConstructionSiteId: Obra.ConstructionSiteId,
        NewFolderName: folderName,
        FolderCurrentId: folderDestination || BreadCrumbItem.Identifier,
      };

      dispatch(ListagemArquivosActions.createFolder(request));
    }
  };

  const handleEditFolder = (folderName: string, file: IFileData) => {
    const request: IFileRenameData = {
      ConstructionSiteId: Number(params.constructionSiteId),
      FileId: file.Identifier.ApiId,
      OldName: file.Name,
      NewName: folderName,
      FolderId: BreadCrumbItem.Identifier,
      constructionSiteDisciplineId: ConstructionSiteDisciplinesId,
      IsFolder: true,
    };
    dispatch(ListagemArquivosActions.renameFile(request));
  };

  const handleUpgradePlan = () => {
    Mixpanel.track({
      name: 'CALL_T0_ACTION',
      props: {
        origin: 'listagem-arquivos',
        originPath: window.location.pathname,
      },
      userInfo,
      currentListTenant: currentTenant,
      tenantIds: tenants && tenants.length > 0
        ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
        : undefined,
    });

    if (userInfo?.CurrentRoleFk === 1) {
      navigate('/faturamento/planos');
    } else {
      window.open('https://bim.maletadoengenheiro.com.br/seja-premium');
    }
  };

  const openModalUpgradeUpload = () => {
    setShowModalUpgradeUpload(true);
  };

  const filteredArchives = useMemo(
    () =>
      ListFiles?.filter(
        (file) =>
          file.Name?.toLowerCase().includes(searchArchives?.toLowerCase()) ||
          file.FileInfo?.Description?.toLowerCase().includes(
            searchArchives?.toLowerCase(),
          ),
      ),
    [ListFiles, searchArchives],
  );

  const iconLeft = () => {
    if ((DisciplineIconsEnum as any)[folderName || BreadCrumbItem.Name]) {
      return (DisciplineIconsEnum as any)[folderName || BreadCrumbItem.Name];
    }
    if (BreadCrumbItem.PreviousItem) {
      return 'arquivar';
    }
    return 'menuContexto';
  };

  const handleTrackDownloadMultiple = () => {
    const selectedFiles = ListFiles.filter((file: any) => {
      return selectedEditRowKeys.includes(
        file.Identifier.ApiId || file.Identifier.ItemId,
      );
    });
    const hasFolder = selectedFiles.some((file: any) => file.IsFolder);
    const onlyFolder = selectedFiles.every((file: any) => file.IsFolder);

    Mixpanel.track({
      name: 'DOWNLOAD_FILE_MULTIPLO',
      props: {
        quantity: selectedEditRowKeys.length,
        api: Number(obraApi),
        constructionSiteId: Number(params.constructionSiteId),
        hasFolder,
        onlyFolder,
        isDownloadViaStream: downloadViaStream,
      },
      userInfo,
      currentListTenant: currentTenant,
      tenantIds: tenants && tenants.length > 0
        ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
        : undefined,
    });
  };

  const handleShowFollowInfoCard = () => {
    dispatch(ListagemArquivosActions.toggleShowInfoCard(true));
  };

  const handleCloseContextMenu = () => {
    contextMenuRef.current?.hide();
  };

  const handleToggleContextMenuPreventClose = (value: boolean) => {
    contextMenuRef.current?.togglePreventClose(value);
  };

  const handleToggleFollowFolder = (files: IFileData[]) => {
    const firstTimeFollowFolder = AppStorage.GetItem('FIRST_TIME_FOLLOW_FOLDER_KEY');
    if (!firstTimeFollowFolder) {
      AppStorage.SetItem('FIRST_TIME_FOLLOW_FOLDER_KEY', 'true', 'local');
      handleShowFollowInfoCard();
    }

    // TODO: Implementar a lógica de seguir pasta
    handleCloseContextMenu();
  };

  const handleOpenFile = (file: IFileData | null, event: number) => {
    if (!file || file.IsFolder) { return; }

    if (isCoordly2DViewerEligible(file.Extension)) {
      const breadCrumbId = BreadCrumbItem.BreadCrumbItemId || BreadCrumbItem.BreadCrumbItemIdDropbox;
      handleOpenCoordly2DViewer(navigate, file, breadCrumbId);
      return handleCloseContextMenu();
    }

    const maxRender = userInfo?.UserStoreItem.MaxQtyRenderedFiles ||
      userInfo?.UserStoreItem.StorePlan?.MaxQtyRenderedFiles;
    const activeRender = userLimitsActive?.QtyRenderedFiles ?? 0;
    const tenantIds = tenants && tenants.length > 0
      ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
      : undefined;

    if (
      maxRender &&
      (activeRender < maxRender) &&
      (extensions2dAnd3d.indexOf(file.Extension.toLocaleLowerCase()) !== -1) &&
      (file.RenderingStatus === null || file.RenderingStatus === 0)
    ) {
      setOpenFileAction({
        csId: Number(params.constructionSiteId),
        ConstructionSiteDisciplinesId,
        record: file,
        constructionSiteName: Obra.Name,
        breadCrumbId: BreadCrumbItem.BreadCrumbItemId || BreadCrumbItem.BreadCrumbItemIdDropbox,
        dispatch,
        constructionSiteApiId: Obra.Api,
        event: event,
      });
      setShowModalLimitRenderFiles(true);
      return handleCloseContextMenu();
    }

    if (
      maxRender &&
      (activeRender >= maxRender) &&
      (extensions2dAnd3d.indexOf(file.Extension.toLocaleLowerCase()) !== -1) &&
      (file.RenderingStatus === null || file.RenderingStatus === 0)
    ) {
      setShowModalRenderUpgrade(true);
      return handleCloseContextMenu();
    }

    handleOpenForgeViewer(
      Number(params.constructionSiteId),
      ConstructionSiteDisciplinesId,
      file,
      BreadCrumbItem.BreadCrumbItemId || BreadCrumbItem.BreadCrumbItemIdDropbox,
      dispatch,
      navigate,
      Obra.Api,
      event,
      userInfo,
      currentTenant,
      tenantIds,
      DisciplineName,
      openModalVisualizationBlockedFiles,
      setOpenFileVisualizationLinkStatus,
      () => setShowModalRenderUpgrade(true),
    );

    return handleCloseContextMenu();
  };

  const handleDownloadFile = (file: IFileData | null) => {
    if (!file || file.IsFolder) { return; }

    const isBlocked = file.Status === 0;
    if (
      openModalDownloadBlockedFiles &&
      AccessPermission.downloadSelectBlockedFiles(currentUserPrivileges) &&
      isBlocked
    ) {
      openModalDownloadBlockedFiles(true, false, false, false);
      return handleCloseContextMenu();
    }
    if (
      openModalDownloadBlockedFiles &&
      !AccessPermission.downloadSelectBlockedFiles(currentUserPrivileges) &&
      AccessPermission.isEngOrConsult()
    ) {
      openModalDownloadBlockedFiles(false, true, false, false);
      return handleCloseContextMenu();
    }
    handleDowload(file.Identifier.ApiId);
    return handleCloseContextMenu();
  };

  const handleEditFile = (file: IFileData | null) => {
    if (!file) { return; }

    if (file.IsFolder) {
      openModalCriarPasta(file);
      return handleCloseContextMenu();
    }

    setActiveRow([file.Identifier.ApiId]);
    return handleCloseContextMenu();
  };

  const handleChangeStatusFile = (
    file: IFileData | null,
    status: FileStatusEnum,
    onClose: () => void,
  ) => {
    if (!file || file.IsFolder) { return; }

    changeStatusFiles(
      [file.Identifier.ApiId],
      ListFiles,
      dispatch,
      status,
      onClose,
    );
    return handleCloseContextMenu();
  };

  const handleOpenHistoryDrawer = (fileData?: IFileData | null) => {
    let title = 'Histórico de Pasta';
    let parentName = BreadCrumbItem.Name;
    let itemId = BreadCrumbItem.Identifier;
    let isFolder = true;

    if (selectedEditRowKeys.length === 0 && !fileData) {
      if (!BreadCrumbItem.PreviousItem) {
        title = 'Histórico de Disciplina';
      } else {
        title = 'Histórico de Pasta';
      }
    }

    if (selectedEditRowKeys.length === 1 || fileData) {
      if (fileData) {
        if (!fileData.IsFolder) {
          title = 'Histórico de Arquivo';
          isFolder = false;
        }
        parentName = fileData.Name;
        itemId = fileData.Identifier.ApiId;
      }

      if (!fileData) {
        const fileIndex = ListFiles.findIndex((file: any) => {
          return file.Identifier.ApiId === selectedEditRowKeys[0];
        });
        if (fileIndex !== -1) {
          if (!ListFiles[fileIndex].IsFolder) {
            title = 'Histórico de Arquivo';
            isFolder = false;
          }
          parentName = ListFiles[fileIndex].Name;
          itemId = ListFiles[fileIndex].Identifier.ApiId;
        }
      }
    }

    handleCloseContextMenu();
    const request: IHistoryFileRequestList = {
      title,
      parentName,
      itemId,
      isFolder,
    };
    dispatch(HistoryActions.listHistoryFileRequest(request));
  };

  const leftBarAndPaddingWidth = isShellCollapsed ? 132 : 307;

  if (showPlotRequestTable) {
    return (
      <SolicitacaoPlotagem
        requestPlotListFiles={requestPlotListFiles}
        breadcrumbs={breadCrumbs}
      />
    );
  }

  return (
    <>
      <SignalR />
      <TabsShell
        ConstructionSiteId={params.constructionSiteId}
        active={PathActiveEnum.detail}
        loading={isLoadingFileList || isLoadingCache || searchLoading}
      />
      <PageHeader name={folderName || BreadCrumbItem.Name} iconLeft={iconLeft()}>
        <div className={styles['headerBreadcrumb']}>
          <BreadCrumb breadcrumbs={breadCrumbs} />
          <UpdateStatus
            status={statusUpdateStatus}
            date={dateUpdateStatus}
            loading={isLoading}
          />
        </div>
        <div className={styles['tableContainer']}>
          {isObsoleteFolder && !selectedEditRowKeys.length ? (
            <TableActionTopbar
              buttons={[]}
              onSearch={setSearchArchives}
              onSearchLoading={setSearchLoading}
              inputPlaceholder='Pesquise por um arquivo'
            />
          ) : (
            <TableActionTopbar
              buttons={
                !isLoadingFileList
                  ? getButtonsTableToolbar({
                    preferencesFeature: followFolderFeature,
                    listFiles: ListFiles,
                    ConstructionSiteDisciplinesId,
                    obra: Obra,
                    selectedRowKeys: selectedEditRowKeys,
                    selectedFiles,
                    showEditTable,
                    breadCrumbItemId:
                      BreadCrumbItem.BreadCrumbItemId ||
                      BreadCrumbItem.BreadCrumbItemIdDropbox,
                    isDownloading,
                    isObsoleteFolder,
                    ObsoleteFolderId,
                    constructionSiteId: request.constructionSiteId,
                    folderId: request.folderId,
                    folderName: request.folderName,
                    disciplineName: DisciplineName,
                    platform: Obra.Api,
                    urlFolder: CloudServiceFolderUrl,
                    breadCrumbPreviousItemId: breadCrumbId,
                    planIsFree: planFree,
                    isLoadingFilesObsoleteList,
                    currentUserPrivileges,
                    userInfo,
                    currentTenant,
                    tenantIds: tenants && tenants.length > 0
                      ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
                      : undefined,
                    flags: { downloadViaStream, newMoveFilesFeature },
                    dispatch,
                    navigate,
                    openModalExclusaoArquivos,
                    openModalDownloadMultiplesFiles,
                    openModalDownloadBlockedFiles,
                    onDownload: () => handleDowload(),
                    desarquivarArquivos,
                    openModalCriarPasta,
                    onOpenHistoryDrawer: handleOpenHistoryDrawer,
                    onToggleFollowFolder: handleToggleFollowFolder,
                    onOpenModalMoveFiles: () => setShowMoveFilesModal(true),
                  })
                  : []
              }
              onSearch={setSearchArchives}
              onSearchLoading={setSearchLoading}
              inputPlaceholder='Pesquise por um arquivo'
            />
          )}
          {isLoadingFileList || isLoadingCache || searchLoading ? (
            <LoadingArchives multiple={11} />
          ) : ListFiles.length ? (
            showEditTable ? (
              <ConfigProvider
                renderEmpty={() =>
                  searchArchives ? (
                    <CustomEmptyData
                      title='Nenhum arquivo encontrado'
                      subtitle='Tente pesquisar pelo nome ou descrição do arquivo.'
                    />
                  ) : (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  )
                }
              >
                <Table
                  className={styles['editTable']}
                  dataSource={filteredArchives
                    .filter(
                      (file: any) =>
                        !file.IsFolder &&
                        (!selectedEditRowKeys.length ||
                          selectedEditRowKeys.includes(
                            file.Identifier.ApiId || file.Identifier.ItemId,
                          )),
                    )
                    .map((fileData: any, index: number) => ({ ...fileData, key: index }))}
                  columns={getColumnsTableEdit({
                    onSubmit,
                    nomenclature,
                    isLoadingRenameFile,
                    editFormIndex,
                    dispatch,
                    obra: Obra,
                    isStageValidation: stagesFeatureValidate,
                    constructionSiteDisciplinesId: ConstructionSiteDisciplinesId,
                  })}
                />
              </ConfigProvider>
            ) : (
              <FileDrop
                dragInfo={BreadCrumbItem.Name}
                onDropFiles={(files) =>
                  updateUploadState(
                    files,
                    params,
                    Obra,
                    BreadCrumbItem,
                    dispatch,
                    ConstructionSiteDisciplinesId,
                    userInfo?.UserStoreItem.MaxQtyUploadFiles ||
                    userInfo?.UserStoreItem.StorePlan?.MaxQtyUploadFiles,
                    openModalUpgradeUpload,
                    folderName,
                    DisciplineName,
                  )
                }
                maxQtyUploadFiles={
                  userInfo?.UserStoreItem.MaxQtyUploadFiles ||
                  userInfo?.UserStoreItem.StorePlan?.MaxQtyUploadFiles
                }
                limitUpload={
                  userInfo?.UserStoreItem.MaxQtyUploadFiles ||
                  userInfo?.UserStoreItem.StorePlan?.MaxQtyUploadFiles
                }
              >
                <ConfigProvider
                  renderEmpty={() =>
                    searchArchives ? (
                      <CustomEmptyData
                        title='Nenhum arquivo encontrado'
                        subtitle='Tente pesquisar pelo nome ou descrição do arquivo.'
                      />
                    ) : (
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    )
                  }
                >
                  <Table
                    virtual
                    scroll={{
                      x: width - leftBarAndPaddingWidth,
                      y: height - 331, // height - (TopBar+PageHeader+ActionBar)
                    }}
                    className={styles['listTable']}
                    columns={getColumnsTable({
                      fileList: ListFiles,
                      filters,
                      constructionSiteId: Obra.ConstructionSiteId || 0,
                      breadCrumbItem: BreadCrumbItem,
                      constructionSiteApiId: Obra.Api,
                      ConstructionSiteDisciplinesId,
                      itemsNotification: filterNotification,
                      itemIdNotification,
                      disciplineName: DisciplineName,
                      showModalLimitRenderFiles,
                      activeRow,
                      isLoadingRenameFile,
                      openLink,
                      isLoadingFilesObsoleteList,
                      currentUserPrivileges,
                      isObsoleteFolder,
                      notificationsObj,
                      openMoreActionsDropdown,
                      preferencesFeature: followFolderFeature,
                      folderId: params.folderId,
                      breadCrumbPreviousItemId: breadCrumbId,
                      dispatch,
                      navigate,
                      onChangeNomenclatureInList,
                      onOpenHistoryDrawer: handleOpenHistoryDrawer,
                      onOpenMoreActionsDropdown: handleOpenMoreActionsDropdown,
                      onCloseMoreActionsDropdown: handleCloseMoreActionsDropdown,
                      onContextMenu: handleContextMenu,
                      onToggleContextMenuPreventClose: handleToggleContextMenuPreventClose,
                      onOpenFile: handleOpenFile,
                      onToggleFollowFolder: handleToggleFollowFolder,
                      onDownloadFile: handleDownloadFile,
                      onEditFile: handleEditFile,
                      onChangeStatusFile: handleChangeStatusFile,
                      onOpenModalExclusaoArquivos: openModalExclusaoArquivos,
                    })}
                    dataSource={filteredArchives?.map((fileData: any, index: number) => ({
                      ...fileData,
                      key: index,
                    }))}
                    rowClassName={styles['file-list-row']}
                    expandable={{
                      expandIcon: () => false,
                      expandedRowKeys: activeRow,
                      expandedRowRender: (record, index) => {
                        if (!record.IsFolder && record.FileInfo) {
                          if (stagesFeatureValidate) {
                            return (
                              <NewEdicaoNomenclatura
                                record={record}
                                nomenclature={nomenclature}
                                obra={Obra}
                                constructionSiteDisciplinesId={ConstructionSiteDisciplinesId}
                                isLoadingRenameFile={isLoadingRenameFile}
                                text={record.Name}
                                islistEdit
                                index={index}
                                onSubmit={onSubmit}
                                onCancel={() => setActiveRow([])}
                              />
                            );
                          }
                          return (
                            <EdicaoNomenclatura
                              record={record}
                              nomenclature={nomenclature}
                              obra={Obra}
                              onSubmit={onSubmit}
                              isLoadingRenameFile={isLoadingRenameFile}
                              text={record.Name}
                              islistEdit
                              onCancel={() => setActiveRow([])}
                              index={index}
                            />
                          );
                        }
                        return null;
                      },
                    }}
                    rowKey={(record: any) =>
                      record.Identifier.ApiId || record.Identifier.ItemId
                    }
                    rowSelection={rowSelection}
                  />
                </ConfigProvider>
              </FileDrop>
            )
          ) : (
            <FileDrop
              dragInfo={BreadCrumbItem.Name}
              onDropFiles={(files) =>
                updateUploadState(
                  files,
                  params,
                  Obra,
                  BreadCrumbItem,
                  dispatch,
                  ConstructionSiteDisciplinesId,
                  userInfo?.UserStoreItem.MaxQtyUploadFiles ||
                  userInfo?.UserStoreItem.StorePlan?.MaxQtyUploadFiles,
                  openModalUpgradeUpload,
                  folderName,
                  DisciplineName,
                )
              }
              maxQtyUploadFiles={
                userInfo?.UserStoreItem.MaxQtyUploadFiles ||
                userInfo?.UserStoreItem.StorePlan?.MaxQtyUploadFiles
              }
              limitUpload={
                userInfo?.UserStoreItem.MaxQtyUploadFiles ||
                userInfo?.UserStoreItem.StorePlan?.MaxQtyUploadFiles
              }
            >
              <div className={styles['emptyListWrap']}>
                <img src={emptyListImage} alt='Pasta vazia' />
                <span className={styles['title']}>
                  Você ainda não possui arquivos nesta pasta, arraste para fazer upload
                </span>
              </div>
            </FileDrop>
          )}
        </div>
        {showModalInfoFiles && (
          <AvisoTamanhoEQuantidadeArquivos
            visible={showModalInfoFiles}
            onConfirm={() =>
              dispatch(ListagemArquivosActions.setShowModalInfoFiles(false))
            }
          />
        )}
        {showModalDeleteFiles && (
          <ExclusaoArquivos
            isLoading={isLoading}
            visible={showModalDeleteFiles}
            dispatch={dispatch}
            onCancel={closeModalExclusaoArquivos}
            deleteFilesRequest={deleteFilesRequest}
          />
        )}
        {showModalCreateFolder && (
          <NovaPasta
            isLoading={isLoading}
            visible={showModalCreateFolder}
            file={editFolder}
            newFolderDestination={newFolderWithDestination}
            onCancel={closeModalCriarPasta}
            onCreate={createFolder}
            onEdit={handleEditFolder}
          />
        )}
        {showModalLimitRenderFiles && (
          <ProgressRenderBar
            value={userLimitsActive?.QtyRenderedFiles || userInfo?.QtyRenderedFiles || 0}
            maxLimits={userInfo?.UserStoreItem.StorePlan?.MaxQtyRenderedFiles}
            visible={showModalLimitRenderFiles}
            role={userInfo?.CurrentRoleFk}
            onCancel={() => setShowModalLimitRenderFiles(false)}
            openFileAction={openFileAction}
            userInfo={userInfo}
            currentTenant={currentTenant}
            tenantIds={tenants && tenants.length > 0
              ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
              : undefined
            }
            disciplineName={DisciplineName}
          />
        )}
        {showModalRenderUpgrade && (
          <AvisoRenderizacaoUpgrade
            visible={showModalRenderUpgrade}
            onCancel={() => setShowModalRenderUpgrade(false)}
          />
        )}
        {showModalVisualizationBlockedFiles && (
          <VisualizacaoBloqueadosModal
            visible={showModalVisualizationBlockedFiles}
            onClose={() => closeModalVisualizationBlockedFiles()}
            onConfirm={() => handleVisualizationBlockedFile()}
            hasPermission={hasPermissionVisualizationBlockedFiles}
          />
        )}
        {showModalUpgradeUpload && (
          <AvisoUploadUpgrade
            visible={showModalUpgradeUpload}
            onCancel={() => setShowModalUpgradeUpload(false)}
            role={userInfo?.CurrentRoleFk}
            planFree={planFree}
            onConfirm={handleUpgradePlan}
            limitUpload={
              userInfo?.UserStoreItem.MaxQtyUploadFiles ||
              userInfo?.UserStoreItem.StorePlan?.MaxQtyUploadFiles
            }
          />
        )}
        <input
          id='uploadFiles'
          type='file'
          hidden
          multiple
          onChange={(e) => {
            updateUploadState(
              e.currentTarget.files,
              params,
              Obra,
              BreadCrumbItem,
              dispatch,
              ConstructionSiteDisciplinesId,
              userInfo?.UserStoreItem.MaxQtyUploadFiles ||
              userInfo?.UserStoreItem.StorePlan?.MaxQtyUploadFiles,
              openModalUpgradeUpload,
              folderName,
              DisciplineName,
            );
            e.currentTarget.value = '';
          }}
        />
        <DownloadModal
          platform={Obra.Api}
          urlFolder={CloudServiceFolderUrl}
          onTrackDownloadMultiple={handleTrackDownloadMultiple}
        />
        {showModalDownloadBlockedFiles && (
          <DownloadBloqueadosModal
            visible={showModalDownloadBlockedFiles}
            blockedParams={blockedParams}
            onClose={() => setShowModalDownloadBlockedFiles(false)}
            onConfirm={() => handleDowload()}
          />
        )}
        {showMoveFilesModal && (
          <MoveFilesModal
            visible={showMoveFilesModal}
            files={selectedFiles}
            constructionSiteId={Number(params.constructionSiteId)}
            oldFolderId={params.folderId}
            onCancel={() => setShowMoveFilesModal(false)}
            onNewFolder={openModalCriarPasta}
          />
        )}

        <ContextMenu ref={contextMenuRef} id={menuId} menuHeight={225} menuWidth={208}>
          <MoreActionsDropdownContent
            record={contextMenuRecord}
            folderId={params.folderId}
            breadCrumbPreviousItemId={breadCrumbId}
            onToggleContextMenuPreventClose={handleToggleContextMenuPreventClose}
            onOpenFile={handleOpenFile}
            onToggleFollowFolder={handleToggleFollowFolder}
            onDownloadFile={handleDownloadFile}
            onEditFile={handleEditFile}
            onChangeStatusFile={handleChangeStatusFile}
            onOpenHistoryDrawer={handleOpenHistoryDrawer}
            onOpenModalExclusaoArquivos={openModalExclusaoArquivos}
            onCloseMoreActionsDropdown={handleCloseMoreActionsDropdown}
          />
        </ContextMenu>
      </PageHeader>
    </>
  );
};

const mapState = (state: IGlobalReducerState) => ({
  ...state.listagemArquivos,
  ...state.auth,
  isLoading: state.listagemArquivos.isLoading,
  TenantUsers: state.tenant.TenantUsers,
  nomenclature: state.nomenclatura.NomenclatureData,
  notificationsMapOld: state.notification.notificationsMap,
  isLoadingFilesObsoleteList: state.listagemArquivos.isLoadingFilesObsoleteList,
  openLink: state.viewer.openFileLink,
  statusUpdateStatus: state.updateStatus.status,
  dateUpdateStatus: state.updateStatus.lastUpdate,
  isLoadingUpdateStatus: state.updateStatus.isLoading,
  isShellCollapsed: state.obra.isCollapsed,
  listArchivesNewDisciplineNoCache: state.disciplina.listArchivesNewDisciplineNoCache,
});

const connector = connect(mapState);

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux;

export default connector(ListagemArquivos);
